import clsx from "clsx";
import ImageUpload from "ui/common/components/input/ImageUpload/ImageUpload";
import { ImageUploadProps } from "ui/common/components/input/ImageUpload/ImageUpload.types";

export type FormGridImageInputProps = ImageUploadProps;

export const FormGridImageInput = ({ className, readonly, showControllers = true, ...rest }: ImageUploadProps) => {
    return (
        <ImageUpload
            className={clsx("form-grid-image-input", className)}
            size="md"
            showControllers={showControllers && !readonly}
            controllersPosition="external"
            readonly={readonly}
            {...rest}
        />
    );
};

export default FormGridImageInput;
